/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Compile stylesheets using webpack
import "stylesheets/application.scss";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
require.context("../../assets/images", false);

import "core-js/stable";
import "regenerator-runtime/runtime";

// Fontawesome
import "../src/fontawesome";

// Debouced events
import debounced from "debounced";
debounced.initialize();

// Rails UJS
require("@rails/ujs").start();

// Turbolinks
import Turbolinks from "turbolinks";
Turbolinks.start();

// Ahoy.js
// import ahoy from "ahoy.js";
// ahoy.trackAll();

// Channels
require("channels");

// Threaded
require("../src/thredded.js");

// Bootstrap
require("../src/bootstrap.js");

// Country Flags
require("../src/country_flags.js");

// Stimulus
import "controllers";

// ViewComponent
import "components";

// ActionText
require("trix");
require("@rails/actiontext");

// Service Worker
require("../src/serviceworker-companion");

import "../src/trix.js";
